import { useQuery } from '@tanstack/react-query'

import { toAgentErrorMessage } from 'features/yieldbirdWrapperAgent/api/errors'
import { reportsQueryOptions } from 'features/yieldbirdWrapperAgent/api/queries'
import { useRestErrorSnackbar } from 'providers/tanstack-query-rest/useRestErrorSnackbar'

import type { ListReportsParams, Report } from 'features/yieldbirdWrapperAgent/api/types'

type UseReports = {
  count: number
  loading: boolean
  reports: Report[]
}

export const useReports = (params: ListReportsParams): UseReports => {
  const { data, error, isFetching } = useQuery(reportsQueryOptions(params))

  useRestErrorSnackbar(error, toAgentErrorMessage)

  return {
    count: data?.total ?? 0,
    loading: isFetching,
    reports: data?.items ?? [],
  }
}
